import {
  CalendarCheck, BookOpen, ClipboardText, ChartBar, ChatsCircle, UsersThree,
  Handshake, FileText, GraduationCap, UsersFour, ChartLineUp, Gear, Trophy,
} from "@phosphor-icons/react";

export const NAV = [
  { id: "home", label: "Home" },
  { id: "about", label: "About Us" },
  { id: "gallery", label: "Photo Gallery" },
  { id: "media", label: "Media Point" },
  { id: "careers", label: "Careers" },
  { id: "achievements", label: "Our Achievements" },
  { id: "contact", label: "Contact" },
];

export const SCHOOLS = [
  {
    slug: "st-thomas", name: "St. Thomas (Altitude) High School", tone: "blue",
  },
  {
    slug: "astrid-rowe", name: "Astrid Rowe Memorial High School", tone: "amber",
  },
];

export const MODULES = [
  { t: "Attendance", d: "Staff & student attendance tracking", Icon: CalendarCheck, c: "text-blue-700", bg: "bg-blue-50" },
  { t: "Academic Plan", d: "Syllabus, lesson plans and daily progress", Icon: BookOpen, c: "text-emerald-700", bg: "bg-emerald-50" },
  { t: "Teacher Tasks", d: "Assign, track and monitor daily work", Icon: ClipboardText, c: "text-violet-700", bg: "bg-violet-50" },
  { t: "Exams & Results", d: "Daily tests, marks and performance analysis", Icon: ChartBar, c: "text-pink-700", bg: "bg-pink-50" },
  { t: "Parent Communication", d: "Notices, meetings and individual updates", Icon: ChatsCircle, c: "text-amber-600", bg: "bg-amber-50" },
  { t: "Student Activities", d: "Homework, projects and overall progress", Icon: UsersThree, c: "text-teal-700", bg: "bg-teal-50" },
  { t: "Meetings & Follow-ups", d: "Agenda, action points and review", Icon: Handshake, c: "text-indigo-700", bg: "bg-indigo-50" },
  { t: "Reports & Analytics", d: "Daily, monthly and term-wise reports", Icon: FileText, c: "text-green-700", bg: "bg-green-50" },
];

export const WHY = [
  { t: "Better Learning for Every Student", Icon: GraduationCap },
  { t: "Strong Collaboration with Parents", Icon: UsersFour },
  { t: "Efficient Administration for Sustainable Growth", Icon: ChartLineUp },
  { t: "A Supportive Environment for Teachers", Icon: Gear },
  { t: "Building Character for a Brighter Tomorrow", Icon: Trophy },
];
